import { z } from 'zod';
/** A placeholder of the contract library, e.g. `fibu.reports_channel`. */
const FieldName = z
    .string()
    .max(80)
    .regex(/^[a-z][a-z0-9_]*(\.[a-z][a-z0-9_]*)*$/);
/** The answers proposed for one value the firm types, in the order they are offered. */
export const FieldAnswers = z
    .object({
    name: FieldName,
    options: z.array(z.string()),
})
    .meta({ id: 'FieldAnswers' });
export const FieldAnswersList = z.array(FieldAnswers).meta({ id: 'FieldAnswersList' });
/**
 * The answers of a value as the Kanos team keeps them: each a line of the documents, none twice.
 * None at all leaves the value to be typed freely.
 */
export const FieldAnswersInput = z
    .object({
    options: z
        .array(z.string().trim().min(1).max(200))
        .max(20)
        .refine((options) => new Set(options).size === options.length, {
        message: 'Each answer only once',
    }),
})
    .meta({ id: 'FieldAnswersInput' });
export const FieldAnswersParams = z.object({ name: FieldName }).meta({ id: 'FieldAnswersParams' });
/**
 * A value the firms type in their contracts, for the Kanos team: as the contract library names
 * it, whether it is a list, and the answers proposed - with who changed them last, if anyone.
 */
export const PlatformContractField = z
    .object({
    name: FieldName,
    description: z.string(),
    kind: z.enum(['text', 'list']),
    /** The documents it stands in, by title. */
    documents: z.array(z.string()),
    options: z.array(z.string()),
    updatedAt: z.iso.datetime({ offset: true }).nullable(),
})
    .meta({ id: 'PlatformContractField' });
export const PlatformContractFieldList = z
    .array(PlatformContractField)
    .meta({ id: 'PlatformContractFieldList' });
//# sourceMappingURL=field-answers.js.map